import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';
import { AdministratorDto } from '@/src/models/AdministratorDto';

const isDev = process.env.REACT_APP_ENV_MODE === 'dev';

interface StoreState {
  auth: AdministratorDto | null;
  token: string | null;
}

interface StoreActions {
  setAuth: (auth: AdministratorDto) => void;
  setToken: (token: string) => void;
  signOut: () => void;
  clearState: () => void;
}

const initialState: StoreState = {
  auth: null,
  token: null,
};

const useAuthStore = create<StoreState & StoreActions>()(
  persist(
    devtools(
      set => ({
        ...initialState,
        setAuth: (auth: AdministratorDto) => set({ auth }),
        setToken: (token: string) => set({ token }),
        signOut: () => set({ auth: null, token: null }),
        clearState: () => set(initialState),
      }),
      { name: 'LangStore', enabled: isDev },
    ),
    {
      name: 'authPersist',
      storage: createJSONStorage(() => localStorage),
    },
  ),
);

export default useAuthStore;
